import { PublicIncomeRangeItem, PublicTimeframeItem } from 'interfaces/publicDashboard'
import { normalize } from 'helpers/normalizeHelpers'

export const PUBLIC_INCOME_RANGES: PublicIncomeRangeItem[] = [
  { id: '40k-', serverValue: 1, name: 'Below $40K' },
  { id: '40k-125k', serverValue: 2, name: '$40K - $125K' },
  { id: '125k+', serverValue: 3, name: 'Above $125K' },
]

export const PUBLIC_INCOME_RANGE_COLLECTION = normalize(PUBLIC_INCOME_RANGES, 'id')

export const PUBLIC_TIMEFRAMES: PublicTimeframeItem[] = [
  { id: '3-months', serverValue: 3, name: 'Last 3 months' },
  { id: '6-months', serverValue: 6, name: 'Last 6 months' },
  { id: '13-months', serverValue: 13, name: 'Last 13 months' },
]

export const PUBLIC_TIMEFRAME_COLLECTION = normalize(PUBLIC_TIMEFRAMES, 'id')

export const MOBILE_KEYVALUE_ITEMS_LIMIT = 5
